import axios from "axios";
import myAppConfig from "../../config";


const postChat = (send) => { //envoie une message d'une conversation vierge
  return axios
    .post(myAppConfig.api.ENDPOINT + "/api/v1/query/", send, { withCredentials: true })
    .then((response) => {
      return response;
    });
}

const postChatInConversation = (send, conversationId) => { // envoie un message dans une conversation existante
  return axios
    .post(myAppConfig.api.ENDPOINT + `/api/v1/query/?conversation_id=${conversationId}`, send, { withCredentials: true })
    .then((response) => {
      return response;
    });
}

const getConversations = () => { // récupère la liste des conversations de l'utilisateur
  return axios
    .get(myAppConfig.api.ENDPOINT + "/api/v1/query/conversations/", { withCredentials: true })
    .then((response) => {
      return response;
    });
}

const getMessages = (conversationId) => { // récupère les messages d'une conversation spécifique
  return axios
    .get(myAppConfig.api.ENDPOINT + `/api/v1/query/messages/${conversationId}`, { withCredentials: true })
    .then((response) => {
      return response;
    });
}

const deleteConversation = (conversationId) => { // supprime une conversation
  return axios
    .delete(myAppConfig.api.ENDPOINT + `/api/v1/conversation/delete_conversation/${conversationId}`, { withCredentials: true })
    .then((response) => {
      return response;
    });
}


const ChatService = {
  postChat,
  postChatInConversation,
  getConversations,
  getMessages,
  deleteConversation,
};

export default ChatService;